import api from './api';

export const billingService = {
  /**
   * Generate billing for a project and month
   * Bill rates are automatically retrieved from employee assignments
   */
  generateBilling: async (projectCode, year, month) => {
    const response = await api.post('/billing/generate', {
      project_code: projectCode,
      year,
      month,
    });
    return response.data;
  },
};
